import { z } from "zod";


export const BancoPagamentoSchema = z.object({
    idBancoPagamento: z.number().optional().nullable(),
    nrConta: z.string().optional().nullable(),
    nrAgencia: z.string().optional().nullable(),
    nomeBanco: z.string().optional().nullable(),
    ativo: z.coerce.boolean().default(true),
    controlaSaldo: z.coerce.boolean().default(false),
    saldoFinal: z.coerce.number().optional().nullable(),

});

export type BancoPagamentoForm = z.infer<typeof BancoPagamentoSchema>;

export const defaultBancoPagamentoForm: Partial<BancoPagamentoForm> = {
    ativo: true,
    controlaSaldo: false,

}